export const BASE_URL =
  process.env.REACT_APP_BACKEND_ROUTE_URL || "http://localhost:8000/app/api/";

/** Mock data is opt-in only; never used as fallback when the live API fails. */
export const USE_MOCK_API =
  process.env.REACT_APP_IPD_ADMISSION_USE_MOCK === "true";

export const API_TIMEOUT_MS = Number(process.env.REACT_APP_IPD_API_TIMEOUT) || 30000;

export const OPD_REFERRALS_PAGE_SIZE = 20;
export const SEARCH_RESULTS_PAGE_SIZE = 10;
